export const store = data => {
  Object.entries(data).forEach(([key, value]) => {
    localStorage.setItem(key, value)
  })
}
